import React from "react";

export default function Footer() {
  const appVersion = process.env.REACT_APP_VERSION || "0.1.0";
  const buildNumber = process.env.REACT_APP_BUILD_NUMBER || "local";

  return (
    <footer className="footer">
      <span>Powered by App Robot • © {new Date().getFullYear()}</span>
      <div className="footer-build-meta">
        Version {appVersion} • Build {buildNumber}
      </div>
    </footer>
  );
}
